var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedInLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_30396_27966)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.1545 0H1.84549C1.35603 0 0.886626 0.194435 0.540531 0.540531C0.194435 0.886626 0 1.35603 0 1.84549V23.1545C0 23.644 0.194435 24.1134 0.540531 24.4595C0.886626 24.8056 1.35603 25 1.84549 25H23.1545C23.644 25 24.1134 24.8056 24.4595 24.4595C24.8056 24.1134 25 23.644 25 23.1545V1.84549C25 1.35603 24.8056 0.886626 24.4595 0.540531C24.1134 0.194435 23.644 0 23.1545 0ZM7.45139 21.2969H3.69271V9.35764H7.45139V21.2969ZM5.56944 7.70312C5.14309 7.70072 4.72699 7.57208 4.37368 7.33342C4.02037 7.09477 3.74567 6.7568 3.58425 6.36218C3.42283 5.96755 3.38192 5.53395 3.4667 5.1161C3.55147 4.69825 3.75813 4.31487 4.06058 4.01436C4.36303 3.71384 4.74772 3.50965 5.16611 3.42756C5.5845 3.34547 6.01783 3.38916 6.41141 3.55311C6.80499 3.71706 7.14119 3.99392 7.37757 4.34876C7.61395 4.7036 7.73992 5.12051 7.73958 5.54688C7.74361 5.83233 7.69012 6.11567 7.5823 6.38C7.47449 6.64434 7.31456 6.88427 7.11205 7.08549C6.90954 7.2867 6.66859 7.44509 6.40357 7.5512C6.13854 7.65731 5.85486 7.70898 5.56944 7.70312ZM21.3056 21.3073H17.5486V14.7847C17.5486 12.8611 16.7309 12.2674 15.6753 12.2674C14.5608 12.2674 13.467 13.1076 13.467 14.8333V21.3073H9.70833V9.36632H13.3229V11.0208H13.3715C13.7344 10.2865 15.0052 9.03125 16.9444 9.03125C19.0417 9.03125 21.3073 10.276 21.3073 13.9219L21.3056 21.3073Z",
    fill: "#0A66C2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_30396_27966"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedInLogo);
export default __webpack_public_path__ + "static/media/linked_In_logo.4700685fce225e1980425759a20d95b6.svg";
export { ForwardRef as ReactComponent };